
export const TOGGLE_LABEL_SELECTION = "[SELECT LABEL] TOGGLE_LABEL_SELECTION";
export const SELECT_LABEL_COLOR = "[SELECT LABEL] SELECT_LABEL_COLOR";
export const RESET_SELECT_LABEL_STATE = "[SELECT LABEL] RESET_SELECT_LABEL_STATE";
export const HIDE_LABEL_SELECTION = "[SELECT LABEL] HIDE_LABEL_SELECTION";


// WEBPACK FOOTER //
// ./src/modules/select-label/select-label-action-types.js